"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const react_1 = __importStar(require("react"));
const lib_1 = require("../../../lib");
const context_1 = __importDefault(require("../context"));
const InputCheckbox = ({ name, label, type, required = false, disabled = false, text = '', checkboxProps = {}, hasError, message, }) => {
    const { obj, updateProperty } = react_1.useContext(context_1.default);
    const useLabelAsText = !text;
    const checkboxText = useLabelAsText ? label + (required ? ' *' : '') : text;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.FormControl, { margin: "dense", fullWidth: true, required: required, error: hasError, component: "fieldset" },
            !useLabelAsText && react_1.default.createElement(core_1.FormLabel, { component: "legend" }, label),
            react_1.default.createElement(core_1.FormControlLabel, { control: react_1.default.createElement(core_1.Checkbox, Object.assign({}, checkboxProps, { checked: !!lib_1.deepGet(obj, name, false), onChange: updateProperty(name, type), value: true })), label: checkboxText, disabled: disabled }),
            message && react_1.default.createElement(core_1.FormHelperText, null, message))));
};
exports.default = InputCheckbox;
//# sourceMappingURL=Checkbox.js.map